import t from 'tcomb';

function is_integer(n) {
  return n === parseInt(n, 10);
}

const Int = t.subtype(t.Num, is_integer);

module.exports = Int;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Int.js
 **/